import "./wixMadefor.css2.js";
const t = "https://static.parastorage.com/services/fonts-data/dist/wixMadefor.j95mkaziqjnrn77aekr8.css";
export {
  t as default
};
//# sourceMappingURL=wixMadefor.css.js.map
